module.exports = __webpack_public_path__ + "static/media/Arve.40589e7f.m4a";